import React from "react";
import { useIntl } from "react-intl";
import CustomPopover from "../../Popover";
import Tooltip from "../../Tooltip";
import { localizedToken } from "../../utils/publisher/variableTokens";

type Props = {
  variables: Record<string, string | null> | undefined;
  insert: (inserted: string, inserted_length?: number) => void;
};

const VariableSelector = ({ variables, insert }: Props) => {
  const intl = useIntl();
  const disabled = Object.keys(variables || {}).length === 0;
  return (
    <CustomPopover
      disabled={disabled}
      position="top"
      button={
        <Tooltip text={intl.formatMessage({ id: "body_editor.insert_variables", defaultMessage: "Insérer des variables personnelles" })} position="bottom">
          <div
            className={`relative flex items-center justify-center text-base bg-gray-100 rounded-full ${
              disabled ? "text-gray-400" : "text-brand_main"
            } size-9 hover:bg-gray-200`}
          >
            $V
          </div>
        </Tooltip>
      }
      panelClasses="drop-shadow-sm"
    >
      <div
        className={`flex flex-col py-2 border rounded bg-white h-32 overflow-y-auto`}
      >
        {Object.keys(variables || {}).map((variable) => {
          const variableKey = variable.replace(/^\$/, "");
          // Token localisé inséré dans le texte (ex. $EMPRESA), normalisé en
          // clé canonique ($ENTREPRISE) au stockage par le BodyEditor.
          const token = `$${localizedToken(intl, variableKey)}`;
          // Variables custom (hors catalogue) : pas de description connue, on retombe
          // sur le token lui-même plutôt que de laisser un tooltip vide.
          const description = intl.formatMessage({
            id: `body_editor.variable_descriptions.${variableKey}`,
            defaultMessage: token,
          });
          return (
            <Tooltip key={`variable_${variable}`} text={description} placement="right">
              <button
                className="px-4 py-1 text-sm font-medium text-gray-700 cursor-pointer hover:text-brand_main hover:bg-gray-100"
                onClick={() => insert(token)}
              >
                {token}
              </button>
            </Tooltip>
          );
        })}
      </div>
    </CustomPopover>
  );
};

export default VariableSelector;
